import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["tagName", "href", "invert", "label"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { forwardRefWithTag } from '@carnica/utils';
import React from 'react';
import { Text } from "../../Text";
export var BreadCrumbsItem = forwardRefWithTag(function (props, ref) {
  var _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'a' : _props$tagName,
    href = props.href,
    invert = props.invert,
    label = props.label,
    otherProps = _objectWithoutProperties(props, _excluded);
  var params = _objectSpread(_objectSpread({}, otherProps), {}, {
    tagName: tagName,
    ref: ref
  });
  return /*#__PURE__*/React.createElement(Text, _extends({}, params, {
    color: invert ? 'secondary-fake-invert' : 'secondary',
    variant: "body-small"
  }, tagName === 'a' ? {
    href: href
  } : {}, {
    "data-t-id": "BreadCrumbs-BreadCrumbsItem"
  }), label);
});